export const CROSSED_PRICE_DISCOUNT_TYPE = 7;
